import { render } from "./SortCaret.vue?vue&type=template&id=72a530be&scoped=true"
import script from "./SortCaret.vue?vue&type=script&lang=js"
export * from "./SortCaret.vue?vue&type=script&lang=js"

import "./SortCaret.vue?vue&type=style&index=0&id=72a530be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a530be"]])

export default __exports__